import { request } from 'data/requests/request';

export interface ISaveIbanRequestData {
    iban: string;
    ibanName: string;
}

const SaveIbanData = (data: ISaveIbanRequestData) =>
    request({
        type: 'saveIbanData',
        url: `buyback/quote/saveIbanData`,
        method: 'POST',
        force: true,
        notApi: true,
        data,
    });

export default SaveIbanData;
